(() => {
  // src/scripts/region-selector.js
  var RegionData = class {
    constructor() {
      this.$parent = document.querySelector(".as-region-selector");
      this.$zoneData = document.querySelector(".as-zones-data");
      this.$regionData = document.querySelector(".as-regions-data");
      this.$localesData = document.querySelector(".as-selector-config-data");
      this.$settingsData = document.querySelector(".as-customize-app-settings-data");
      if (!this.$parent || !this.$regionData)
        return;
      this.$data = {};
      this.$settings = {};
      this.$showModal = false;
      this.$stores = this.$parent.querySelector(".as-stores-wrap");
      this.$selectedRegionCookie = "selectedRegion";
      this.$host = window.location.host;
      this.$path ='';
      this.$targetRegion = {};
      this.$selectorModal = this.$parent.querySelector(".as-selector-modal");
      this.$selectorDropdown = this.$parent.querySelector(".as-selector-dropdown");
      this.init();
    }
    init() {
      this.handleMetaData();
      this.initSelectorStatus();
    }
    handleMetaData() {
      var _a, _b;
      this.$data.areas = this.$zoneData && JSON.parse(this.$zoneData.innerHTML);
      this.$data.regions = this.$regionData && JSON.parse(this.$regionData.innerHTML);
      const initLocales = JSON.stringify({
        locales: []
      });
      this.$data.locales = (_b = JSON.parse(this.$localesData && ((_a = JSON.parse(this.$localesData.innerHTML).find((item) => item.configType === 2)) == null ? void 0 : _a.content) || initLocales)) == null ? void 0 : _b.locales;
      this.$settings = this.$settingsData && JSON.parse(this.$settingsData.innerHTML).settings;
      if (this.$path.length > 1) {
        this.$data.regions.map((item) => {
          item.websiteUrl = item.websiteUrl + this.$path;
        });
      }
      this.$data.areas.map((item) => {
        item.regions = this.$data.regions.filter((regionItem) => regionItem.zoneId === item.id);
      });
    }
    initSelectorStatus() {
      if (this.$settings && !this.$settings.enableSelector) {
        this.$parent.remove();
        return;
      } else {
        this.$parent.classList.remove("d-none");
      }
      this.initStyle();
      this.renderSelectedStore();
      this.sortRegionList();
      this.renderCopyWritting();
      this.renderRegionList();
      this.initOtherSettings();
      this.initSelector();
    }
    initStyle() {
      var _a, _b, _c, _d;
      this.$parent.style.backgroundColor = (_a = this.$settings) == null ? void 0 : _a.selectorBg;
      this.$parent.style.color = (_b = this.$settings) == null ? void 0 : _b.selectorText;
      if (this.$settings && this.$settings.selectorDropdown) {
        this.$wrap = this.$selectorDropdown;
        this.$selectorDropdown.classList.remove("d-none");
        this.$selectorModal.remove();
        this.$stores.style.backgroundColor = (_c = this.$settings) == null ? void 0 : _c.selectorBg;
      } else {
        this.$wrap = this.$selectorModal;
        this.$selectorModal.classList.remove("d-none");
        this.$selectorDropdown.remove();
        this.$showModal = true;
        this.$wrap.classList.add((_d = this.$settings) == null ? void 0 : _d.selectorModalStyle);
      }
    }
    sortRegionList() {
      var _a;
      if (this.$showModal && ((_a = this.$settings) == null ? void 0 : _a.showArea)) {
        this.$data.areas.map((item) => {
          var _a2;
          (_a2 = item.regions) == null ? void 0 : _a2.sort(this.sortData("name"));
        });
      }
      this.$data.regions.sort(this.sortData("name"));
    }
    sortData(property) {
      return function(a, b) {
        if (a[property] > b[property]) {
          return 1;
        }
        if (a[property] < b[property]) {
          return -1;
        }
        return 0;
      };
    }
    renderCopyWritting() {
      if (!this.$showModal)
        return;
      let targetLocale = this.$data.locales.find((item) => {
        var _a;
        return item.isoCode == ((_a = this.$targetRegion) == null ? void 0 : _a.languageIsoCode);
      });
      targetLocale && targetLocale.title && (this.$wrap.querySelector(".as-modal-title").textContent = targetLocale == null ? void 0 : targetLocale.title);
    }
    renderRegionList() {
      var _a;
      if (this.$showModal) {
        if ((_a = this.$settings) == null ? void 0 : _a.showArea) {
          this.$data.areas.map((item, index) => {
            var _a2;
            let newNode = document.createElement("div");
            let areaHtml = this.$parent.querySelector(".as-modal-list-with-area-template").innerHTML.replace(/#{area}/g, item.name).replace(/#{index}/g, index);
            newNode.innerHTML = areaHtml;
            let regionWrap = newNode.querySelector(".as-regions-wrap");
            (_a2 = item.regions) == null ? void 0 : _a2.map((item2) => {
              var wrapper = document.createElement("li");
              wrapper.classList.add("col");
              let regionHtml = this.$parent.querySelector(".as-region-list-template").innerHTML.replace("#{url}", item2.websiteUrl).replace("#{region}", item2.localName || item2.name).replace("#{language}", item2.languageLocalName || item2.languageName).replace(/#{isoCode}/g, item2.isoCode.toUpperCase());
              wrapper.innerHTML = regionHtml;
              regionWrap.appendChild(wrapper);
            });
            this.$wrap.querySelector(".as-modal-region-list-with-region").appendChild(newNode);
          });
          this.initCollapse();
        } else {
          this.$data.regions.map((item) => {
            let newNode = document.createElement("li");
            newNode.classList.add("col");
            let listHtmlTemplate = this.$parent.querySelector(".as-region-list-template").innerHTML;
            let newHtml = listHtmlTemplate.replace("#{url}", item.websiteUrl).replace("#{region}", item.localName || item.name).replace("#{url}", item.websiteUrl).replace("#{language}", item.languageLocalName || item.languageName).replace(/#{isoCode}/g, item.isoCode.toUpperCase());
            newNode.innerHTML = newHtml;
            this.$wrap.querySelector(".as-modal-region-list-without-region").appendChild(newNode);
          });
        }
      } else {
        let dropdownLists = this.$parent.querySelector(".as-dropdown-lists");
        if (!dropdownLists)
          return;
        this.$data.regions.map((item) => {
          let newNode = document.createElement("li");
          let listHtmlTemplate = this.$parent.querySelector(".as-list-html").innerHTML;
          let newHtml = listHtmlTemplate.replace("#{url}", item.websiteUrl).replace("#{region}", item.localName || item.name).replace("#{language}", item.languageLocalName || item.languageName).replace(/#{isoCode}/g, item.isoCode.toUpperCase());
          newNode.innerHTML = newHtml;
          dropdownLists.appendChild(newNode);
        });
      }
    }
    initCollapse() {
      let collapseBtn = this.$parent.querySelectorAll(".as-collapse-btn");
      collapseBtn.forEach((item) => {
        item.addEventListener("click", (event) => {
          item.classList.toggle("collapsed");
          item.ariaExpanded == "true" ? item.ariaExpanded = "false" : item.ariaExpanded = "true";
          item.nextElementSibling.classList.toggle("show");
        });
      });
    }
    getCookie(name) {
      let match = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
      if (match)
        return match[2];
    }
    renderSelectedStore() {
      var _a, _b, _c, _d, _e, _f;
      let $selectedRegion = this.$wrap.querySelector(".as-selected-store");
      let $selectedLanguage = this.$wrap.querySelector(".as-selected-language");
      let $selectedFlag = this.$wrap.querySelector(".as-featured-flag");
      let showCookieTarget;
      let cookieTarget;
      if (this.getCookie(this.$selectedRegionCookie)) {
        cookieTarget = this.$data.regions.find((item) => item.isoCode.toUpperCase() == this.getCookie(this.$selectedRegionCookie));
        if (cookieTarget) {
          try {
            ((_a = new URL(cookieTarget.websiteUrl)) == null ? void 0 : _a.host) == this.$host ? showCookieTarget = true : showCookieTarget = false;
          } catch (error) {
            showCookieTarget = false;
          }
        }
      }
      if (showCookieTarget) {
        this.$targetRegion = cookieTarget;
      } else {
        try {
          this.$targetRegion = this.$data.regions.filter((item) => {
            var _a2;
            return ((_a2 = new URL(item.websiteUrl)) == null ? void 0 : _a2.host) == this.$host;
          }).find((item) => item.isRecommended) || this.$data.regions.find((item) => {
            var _a2;
            return ((_a2 = new URL(item.websiteUrl)) == null ? void 0 : _a2.host) == this.$host;
          }) || this.$data.regions.find((item) => item.isRecommended);
        } catch (error) {
          this.$targetRegion = this.$data.regions.find((item) => item.isRecommended);
        }
      }
      $selectedRegion.textContent = ((_b = this.$targetRegion) == null ? void 0 : _b.localName) || ((_c = this.$targetRegion) == null ? void 0 : _c.name);
      $selectedLanguage.textContent = `( ${((_d = this.$targetRegion) == null ? void 0 : _d.languageLocalName) || ((_e = this.$targetRegion) == null ? void 0 : _e.languageName)} )`;
      $selectedFlag.classList.add(`sc-${(_f = this.$targetRegion) == null ? void 0 : _f.isoCode.toUpperCase()}`);
    }
    initOtherSettings() {
      var _a, _b;
      if (!((_a = this.$settings) == null ? void 0 : _a.showLanguage)) {
        this.$parent.classList.add("no-language");
      }
      if (!((_b = this.$settings) == null ? void 0 : _b.showFlag)) {
        this.$parent.classList.add("use-default-flag");
      }
    }
    initSelector() {
      this.$storeItem = this.$parent.querySelectorAll(".as-store");
      Array.from(this.$storeItem).map((item) => {
        item.addEventListener("click", () => {
          if (document.domain.split(".").slice(-2).join(".") !== "myshopify.com") {
            document.cookie = `${this.$selectedRegionCookie}=${item.dataset.regionCode};path=/;domain=${document.domain.split(".").slice(-2).join(".")}`;
          } else {
            document.cookie = `${this.$selectedRegionCookie}=${item.dataset.regionCode};path=/`;
          }
        });
      });
    }
  };
  new RegionData();
})();